import type { TargetedPointerEvent } from "preact";
import type {
	BrickPosition,
	NumberOfBricks,
} from "@brickme/project-core/src/model/picture.ts";
import type { PixelPosition } from "@brickme/project-core/src/model/geom.ts";

function getCanvasPixelPosition(
	e: Pick<
		TargetedPointerEvent<Element>,
		"currentTarget" | "clientX" | "clientY"
	>,
): PixelPosition | undefined {
	// Used to do this when worked for mouse or touch event
	// const touches: readonly { clientX: number; clientY: number }[] =
	// 	"clientX" in e
	// 		? [e]
	// 		: Array.from({ length: e.touches.length }, (_, i) => e.touches[i]);

	// // This happens for ontouchend. But also good to have it as a safeguard in case occurs elsewhere.
	// if (touches.length === 0) {
	// 	return undefined;
	// }

	const rect = e.currentTarget.getBoundingClientRect();
	return { x: e.clientX - rect.left, y: e.clientY - rect.top };
}

function canvasPositionToBrick(
	canvas: Element,
	pixelPosition: PixelPosition,
	numberOfBricks: NumberOfBricks,
): BrickPosition {
	const bounding = canvas.getBoundingClientRect();
	const xRatio = pixelPosition.x / bounding.width;
	const yRatio = pixelPosition.y / bounding.height;
	const x = Math.min(
		Math.floor(xRatio * numberOfBricks.width),
		numberOfBricks.width - 1,
	);
	const y = Math.min(
		Math.floor(yRatio * numberOfBricks.height),
		numberOfBricks.height - 1,
	);
	return { x, y };
}

export { getCanvasPixelPosition, canvasPositionToBrick };
